import { render } from "./budgets-model.vue?vue&type=template&id=16ec3645"
import script from "./budgets-model.vue?vue&type=script&lang=js"
export * from "./budgets-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__